import React from 'react';
import './MiscellaneousTutorialsBoxs.scss';

export default function MiscellaneousTutorialsBoxs(): React.ReactElement {
  return (
    <div className="boxs">
      <div className="boxs__changes">
        <h4>Suggested changes</h4>
        <p>
          The content on docs.arduino.cc is facilitated through a public <a href="https://github.com/arduino/docs-content">GitHub repository</a>. You
          can read more on how to contribute in the{' '}
          <a href="https://github.com/arduino/docs-content/blob/main/CONTRIBUTING.md">contribution policy</a>.
        </p>
      </div>
      <div className="boxs__support">
        <h4>Need support?</h4>
        <a href="https://support.arduino.cc/">Help Center</a>
        <a href="https://forum.arduino.cc/">Ask the Arduino Forum</a>
        <a href="https://discord.gg/jQJFwW7">Discover Arduino Discord</a>
      </div>
      <div className="boxs__license">
        <h4>License</h4>
        <p>
          The Arduino documentation is licensed under the{' '}
          <a href="https://creativecommons.org/licenses/by-sa/4.0/">Creative Commons Attribution-Share Alike 4.0</a> license.
        </p>
      </div>
    </div>
  );
}
